export default function isEmpty(v: unknown): boolean {
  return (
    v === false ||
    v === undefined ||
    v === null ||
    (v as Array<unknown>).length === 0
  );
}
